export default {
  setDeliveryDirectMailFlag({ commit }, payload) {
    // console.log(222, payload);
    commit("DeliveryDirectMailFlagActions", payload);
  },
  setPrintPublicationTypeBoxFlag({ commit }, payload) {
    // console.log("action", payload);
    commit("PrintPublicationTypeBoxFlag", payload);
  },
  setEmailElectronicTypeBoxFlag({ commit }, payload) {
    commit("EmailElectronicTypeBoxFlagActions", payload);
  },
  setSocialNetworkNameBoxFlag({ commit }, payload) {
    commit("SocialNetworkNameBoxFlagActions", payload);
  },
  setBankingOptionBoxFlag({ commit }, payload) {
    commit("BankingOptionBoxFlagActions", payload);
  },
  setCreditOptionBoxFlag({ commit }, payload) {
    // console.log("cr", payload);
    commit("CreditOptionBoxFlagActions", payload);
  },
  setAutomativeOptionBoxFlag({ commit }, payload) {
    // console.log("cr", payload);
    commit("automativeOptionBoxFlagActions", payload);
  },
  setBankingSectorOptionBoxFlag({ commit }, payload) {
    // console.log("cr", payload);
    commit("BankingSectorOptionBoxFlagActions", payload);
  },
  setCreditCardSectorBoxFlag({ commit }, payload) {
    // console.log("cr", payload);
    commit("CreditCardSectorOptionBoxFlagActions", payload);
  },
  setDashboardDirectMailBoxFlagAction({ commit }, payload) {
    // console.log("cr", payload);
    commit("DashboardDirectMailBoxFlagMut", payload);
  },
  setDashboardDirectMailEmailBoxFlagAction({ commit }, payload) {
    // console.log("cr", payload);
    commit("DashboardDirectMailEmailBoxFlagMut", payload);
  },
  setDashboardBoxFlagAction({ commit }, payload) {
    // console.log("cr", payload);
    commit("DashboardBoxFlagMut", payload);
  },
  setselectedDataAction({ commit }, payload) {
    // console.log("cr", payload["sectors"]);
    commit("selectedDataMut", payload);
  },
  setAdditionalSelectedDataAction({ commit }, payload) {
    // console.log("cr", payload["sectors"]);
    commit("additionalSelectedDataMut", payload);
  },
  setlastSearchTriggerredAction({ commit }, payload) {
    // console.log("cr", payload["sectors"]);
    commit("lastSearchTriggerredMut", payload);
  },
};
